export const WhoWeAre = () => {
  return (
    <div className='px-8 mt-8 sm:mt-0 mb-8 sm:my-0 sm:p-8'>
      <h2
        id='services'
        className='text-lg font-semibold text-center mb-8 text-transform: uppercase'
      >
        WHO WE ARE !
      </h2>

      <div className='flex flex-col sm:flex-row gap-6'>
        <div className='flex-1 border-[1px] rounded-md p-4'>
          <h3 className='font-medium text-md mb-2 text-transform: uppercase text-[indigo]'>
            Mission
          </h3>
          <p className='text-[12px]'>
            Our mission is to empower individuals and communities globally
            through innovative digital solutions that enable accessible and
            decentralized participation in the real estate ecosystem.
          </p>
        </div>

        <div className='flex-1 border-[1px] rounded-md p-4'>
          <h3 className='font-medium text-md mb-2 text-transform: uppercase text-[indigo]'>
            Vision
          </h3>
          <p className='text-[12px]'>
            To build the world&apos;s leading digital real estate ecosystem,
            decentralizing access, ownership, and sustainable wealth creation
            for all.
          </p>
        </div>
      </div>
    </div>
  );
};
